import EvergreenUrgentBanner from './EvergreenUrgentBanner'

export default EvergreenUrgentBanner

export { default as EvergreenMessagingProvider } from './EvergreenMessagingProvider'
export { useEvergreenMessaging } from './EvergreenMessagingProvider'
export { default as EvergreenMoreInfo } from './EvergreenMoreInfo'
export { EVERGREEN_BANNER_SLUG } from './types'
export type {
  EvergreenMessagingConfig,
  EvergreenUrgentBannerProps,
  UseEvergreenMessagingReturn,
} from './types'
